import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import moment from  'moment';
import NotificationSystem from 'react-notification-system';
import Modal from 'react-modal';
import Datetime from 'react-datetime';
import {_addNotification, _addNotificationError} from "../../../server/util";
import { get,postWithHeadersResponse,postWithHeaders } from '../../../server/actions'
import {Doughnut} from 'react-chartjs-2';
var _ = require('lodash');
const data = {
	labels: [
		'Red',
		'Green',
		'Yellow'
	],
	datasets: [{
		data: [300, 50, 100],
		backgroundColor: [
		'#FF6384',
		'#36A2EB',
		'#FFCE56'
		],
		hoverBackgroundColor: [
		'#FF6384',
		'#36A2EB',
		'#FFCE56'
		]
	}]
};
class DashboardCharts extends Component {
    constructor(props){
        super(props);
    }
    render(){
        return(<section className="full-width clearfix">
         <NotificationSystem ref="notificationSystem"/>
         <div className="container">
                    <div className="sectionTitle">
                        <h2>
                            <div className="row">
                                <div className="col-xs-12">
                            <label className="col-xs-6 text-left" style={{paddingLeft:'0px'}}>Admin Dashboard</label>
                           
                            </div>
                            </div>
                        </h2>
                    </div>


                    <div className="row school-admin-dashboard">
            <Doughnut data={data} />
            </div>
            </div>

        </section>)
    }
}
export default DashboardCharts


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Home/dashboardCharts.jsx